'use client';

import { Provider } from 'react-redux';
import { store } from './store';
import { ReactNode } from 'react';
import { ThemeProvider } from 'lib/theme-provider';
import { Toaster } from 'src/components/shadcn/ui/toaster';

interface ProvidersProps {
  children: ReactNode;
}

const Providers = ({ children }: ProvidersProps) => {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      <Provider store={store}>
        {children}
        <Toaster />
      </Provider>
    </ThemeProvider>
  );
};

export default Providers;
